import { values } from 'lodash'
import { createSelector } from 'reselect'

import { makeFilterRugs, makeSortRugs } from 'Global/Helpers/rugHelpers'
import { userPermissions as _userPermissions } from 'Components/Permissions/selectors'

const _page = state => state.layout.requestedRugs.page
const _rugs = state => state.rugs.data

export const layout = state => state.layout.requestedRugs.layout
export const limit = state => state.layout.requestedRugs.limit
export const previewOpen = state => state.previewModal.requestedRugs.visible
export const rugsDone = state => state.rugs.done
export const rugsError = state => state.rugs.error
export const rugsPending = state => state.rugs.pending
export const sortBy = state => state.layout.requestedRugs.sortBy
export const sortOrder = state => state.layout.requestedRugs.sortOrder
export const user = state => state.auth.user

/**
 * Iterates over all rugs and filters out all rugs
 * which aren't marked for designers.
 * @returns {array} Filtered Rugs
 */
export const filterRugs = createSelector(
  [sortBy, sortOrder, _rugs, _userPermissions],
  (sortBy, sortOrder, rugs, userPermissions) => {
    const filter = makeFilterRugs({}, userPermissions)
    const sort = makeSortRugs(sortBy, sortOrder)

    return values(rugs)
      .filter(filter)
      .filter(r => r.requests.filter(req => !req.deleted && !req.fulfilled).length > 0)
      .sort(sort)
  },
)

/**
 * Takes the filtered rugs and slices the array to the set limit per page.
 */
export const slicedFilteredRugs = createSelector(
  [filterRugs, limit, _page],
  (filteredRugs, limit, page) => {
    return filteredRugs.slice((page - 1) * limit, (page - 1) * limit + limit)
  },
)

/**
 * Creates a pagination object with current page, total pages, total rugs
 */
export const calculatePagination = createSelector(
  [filterRugs, limit, _page],
  (filteredRugs, limit, page) => {
    return {
      page,
      pages: Math.ceil(filteredRugs.length / limit),
      totalRugs: filteredRugs.length,
    }
  },
)
